export default __webpack_public_path__ + "static/logo-bmw-a5d6a135bf3767d8293cc64f850c012b.png";